<template>
    <div class="d-flex flex-column h-100">
        <div class="d-flex justify-content-between mb-3">
            <div class="font-weight-medium">Billing Address</div>
            <b-button variant="link"
                      class="p-0"
                      v-if="hasBillingAddress"
                      @click="organizationModal = true">
                Update Billing
            </b-button>
        </div>

        <div class="d-flex flex-column justify-content-center flex-grow-1">
            <div v-if="hasBillingAddress">
                <div class="text-heading mb-2">PRIMARY BILLING ADDRESS</div>
                <div>{{composedAddress}}</div>
                <div>{{organization.billing_state}}</div>
                <div>{{organization.billing_zip}}</div>
                <div>{{organization.billing_country}}</div>
            </div>
            <div v-else>
                <div class="d-flex flex-column align-items-center py-3">
                    <h5>No billing address on file</h5>
                    <div>Preferred billing address will appear here</div>
                    <b-button variant="link" @click="organizationModal = true">Add Billing Address</b-button>
                </div>
            </div>
        </div>

        <b-modal v-model="organizationModal" title="Update Billing"  hide-footer>
            <div v-bind:class="{alert: activeError, 'alert-danger': activeError}" role="alert" v-html="errorText"></div>

            <organization-billing-form :organization="organization"
                                       :saving="saving"
                                       @cancel="handleUpdateCancel"
                                       @save="updateOrganization"/>
        </b-modal>
    </div>
</template>

<script>
  import OrganizationBillingForm from "./OrganizationBillingForm";
  import normalize from "json-api-normalize";
  import Attributes from "../../../models/Attributes";
  import GeneralMixins from "../../../mixins/GeneralMixins";

  export default {
    components: {OrganizationBillingForm},
    mixins: [GeneralMixins],
    props: ['organizationUrl', 'initialOrganization'],

    data: function () {
      return {
        organization: this.initialOrganization,
        organizationModal: false,
        saving: false,
        activeError: false,
        errorText: '',
      }
    },

    methods: {
      setError: function (error) {
        this.activeError = true;
        this.errorText = error;
      },

      removeError: function () {
        this.activeError = false;
        this.errorText = '';
      },

      updateOrganization: function (params) {
        this.saving = true;
        this.$http.patch(this.organizationUrl, params).then(fulfilled => {
          this.organization = normalize(fulfilled.body).get(Attributes.organizationAttributes);
          this.organizationModal = false;
          this.showToast("Billing info was updated")
        }, rejected => {
          this.setError(this.getErrorMessagesHtml(rejected.body))
        }).then(() => this.saving = false)
      },

      handleUpdateCancel: function () {
        this.removeError();
        this.organizationModal = false;
      }
    },

    computed: {
      hasBillingAddress: function () {
        const org = this.organization;
        return [org.billing_address_line_1, org.billing_address_line_2, org.billing_country, org.billing_state, org.billing_city, org.billing_zip].find(el => el && el.length > 0)
      },

      composedAddress: function () {
        return [
          this.organization.billing_address_line_1,
          this.organization.billing_address_line_2,
          this.organization.billing_city
        ].filter(str => str && str.length > 0).join(', ')
      }
    }
  }
</script>